export const escapeRegExp = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const maskWords = (text, wordList, replacement = '***') => {
  if (typeof text !== 'string' || !Array.isArray(wordList) || wordList.length === 0) {
    return text;
  }
  const escapedWords = wordList.map(escapeRegExp);
  const pattern = `(?<!\\p{L})(?:${escapedWords.join('|')})(?!\\p{L})`;
  const regex = new RegExp(pattern, 'giu');
  return text.replace(regex, replacement);
}

export const getMaskWordsFromEnv = (envVar) => {
  if (typeof envVar !== 'string' || !envVar.trim()) return [];
  return envVar
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
}

export const maskText = (text, replacement = '***') => {
  const maskEnv = process.env.REACT_APP_STRING_MASK || '';
  const words = getMaskWordsFromEnv(maskEnv);
  return maskWords(text, words, replacement);
}
